import React from 'react';

type DefaultsProps<TProps, TDefaultsKeys extends keyof TProps> = { [TKey in TDefaultsKeys]-?: TProps[TKey] };

/* fixes React.FunctionalComponent's defaultProps type */
type FixDefaults<
  TComp extends React.FC<TProps>,
  TProps,
  TDefaultPropsKeys extends keyof TProps,
  TDefaultProps extends DefaultsProps<TProps, TDefaultPropsKeys>
> = Pick<TComp, Exclude<keyof TComp, 'defaultProps'>> &
  (TComp extends (props: infer P, ...a: infer A) => infer R
    ? (props: Omit<P, TDefaultPropsKeys> & Partial<TDefaultProps>, ...a: A) => R
    : never) & {
    defaultProps: TDefaultProps;
  };

export const declareWithDefaults = <TProps, TDefaultsKeys extends keyof TProps>(
  comp: React.FC<TProps>,
  defaultProps: DefaultsProps<TProps, TDefaultsKeys>,
): FixDefaults<React.FC<TProps>, TProps, TDefaultsKeys, DefaultsProps<TProps, TDefaultsKeys>> => {
  const compWithDefaultProps = comp;
  compWithDefaultProps.defaultProps = defaultProps as any;
  return comp as any;
};
